import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { Factura } from '@shared/models/facturacion/Factura';
import { Remito } from '@shared/models/facturacion/Remito';
import { TipoMoneda } from '@shared/enums/tipoMoneda';
import { ImpuestoPercepcion } from '@shared/models/facturacion';
import { TipoMovimiento } from '@shared/models/facturacion/TipoMovimiento';
import { EstadoFactura } from '@shared/enums/EstadoFactura';
import { CodigoImpuesto } from '@shared/enums/codigoImpuesto';
import { environment } from '@environments';

@Component({
  selector: 'app-previsualizacion-comprobante',
  templateUrl: './previsualizacion-comprobante.component.html',
  styleUrls: ['./previsualizacion-comprobante.component.css']
})
export class PrevisualizacionComprobanteComponent implements OnInit {

  @Input() remitosSeleccionados: Remito[] = [];
  @Input() facturaCalculada: Factura[];
  @Input() idRefacturacion: string;

  facturaEmitida: Factura[] = [];
  remitosId: string[] = [];
  columnas: any[] = [];
  obteniendoFactura: boolean = false;
  facturando: boolean = false;
  calcFact: boolean = false;
  exportando: boolean = false;
  elementType = 'url';
  aeroplantaSoloPad: boolean = false;

  facturaAEmitir = new UntypedFormGroup({});
  TipoMovimiento=TipoMovimiento;
  EstadoFactura=EstadoFactura;

  entornoProduccion: boolean = (environment.name == "production");

  constructor(public modal: NgbModal, public activeModal: NgbActiveModal, private facturacionService: ComprobanteService) { }
  ngOnInit() {

    this.calcFact = true;
    this.remitosSeleccionados.forEach(element => this.remitosId.push(element.id));

    if (this.facturaCalculada === null) {
      this.obtenerFacturaCalculada(this.remitosId);
    }

    this.columnas = [
      { field: 'Codigo', header: 'Cod.' },
      { field: 'Detalle', header: 'Descripción' },
      { field: 'Cantidad', header: 'Cant.' },
      { field: 'PUnitario', header: 'Valor Unitario' },
      { field: 'Total', header: 'Total' },
    ];
  }

  obtenerFacturaCalculada(remitos: string[]) {
    this.obteniendoFactura = true;
    this.facturacionService.obtenerFacturaCalculada(remitos)
      .subscribe(result => {
        this.facturaCalculada = result;
        //this.spinner.hide('spinnerFactura');
        this.obteniendoFactura = false;
        // this.aeroplanta = this.usuarioService.aeroplantas.filter((a => a.codigoAeroplanta == this.facturaCalculada.codigoAeroplanta));
        // this.aeroplantaSoloPad = this.aeroplanta[0].soloPAD;
      })
  }

  // pantalla

  set_format_cuit(cuit: string) {
    if (cuit.includes("-")){
      return (cuit)
    }else{
      cuit = cuit.substr(0, 2) + - + cuit.substr(2, 8) + - + cuit.substr(10);
    return (cuit)
    }    
  }

  // validaciones

  clienteDiscriminaImpuestos(factura: Factura) {
    if (factura.cliente.condicionIvaDiscrimina) {
      return true;
    } else {
      return false;
    }
  }

  clienteConsumidorFinal(factura: Factura) {
    // como las leyendaSimple no son retroactivas, se generan a partir de la generacion de la factura
    // el backend actualiza del 2025 en adelante, las demás se descartan del circuito
    const fechaLimite = this.entornoProduccion ? new Date(2025, 1, 3) : new Date(2025, 0, 28);
    const fechaEmision = factura?.fechaEmision ? new Date(factura.fechaEmision) : null;

    return fechaEmision !== null &&
          fechaEmision >= fechaLimite &&
          (factura?.tipoMovimiento === TipoMovimiento.FAB || factura?.tipoMovimiento === TipoMovimiento.NCB || factura?.tipoMovimiento === TipoMovimiento.NDB);
  }

  clienteExento(factura: Factura) {
    return (factura.cliente.condicionIvaCodigoAfip == '02');
  }

  // getters

  obtenerPorcentaje(factura, leyenda: string): number {
    for (const reng of factura.renglones) {
      for (const imp of reng.impuestosPercepciones) {
        if (imp.leyenda == leyenda) {
          return imp.valor;
        }
      }
    }
  }

  obtenerDescripcionMoneda(tipoMoneda: TipoMoneda): string {
    return tipoMoneda == TipoMoneda.PES ? 'PESOS' : 'DOLARES';
  }

  incluirPorcentajeImpuesto(codigo: CodigoImpuesto): boolean {
    if(codigo === CodigoImpuesto.IDC || codigo === CodigoImpuesto.ITC){
      return false;
    }else{
      return true;
    }
  }

  obtenerImpuestosSobreCombustiblesLiquidos(impuestos: ImpuestoPercepcion[]): ImpuestoPercepcion[] {
    return impuestos.filter((impuesto) => !this.incluirPorcentajeImpuesto(impuesto.codigo));
  }

  obtenerImpuestosValorAgregado(impuestos: ImpuestoPercepcion[]): ImpuestoPercepcion[] {
    return impuestos.filter((impuesto) => impuesto.leyenda.includes('IVA'));
  }
}
